import AsyncStorage from '@react-native-async-storage/async-storage';

import { PaymentAccountActivationDraft } from '@/types/payment-account';

/**
 * Rascunho do assistente de ativação, só no aparelho (PLANO, seção 2.5 e
 * T4.3: "Rascunho só no aparelho, e só dos campos não sensíveis"). Guarda
 * **apenas** `PaymentAccountActivationDraft` (endereço e banco) — CPF, data
 * de nascimento e a resposta de PEP nunca passam por aqui, ficam só em
 * memória do componente até o envio único ao servidor.
 */
const DRAFT_STORAGE_KEY = 'payment-account-activation-draft';

export async function loadPaymentAccountDraft(): Promise<PaymentAccountActivationDraft | null> {
  try {
    const raw = await AsyncStorage.getItem(DRAFT_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PaymentAccountActivationDraft;
  } catch {
    return null;
  }
}

export async function savePaymentAccountDraft(draft: PaymentAccountActivationDraft): Promise<void> {
  try {
    await AsyncStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(draft));
  } catch {
    // Rascunho é conveniência, não dado crítico: falha de storage não deve
    // travar o assistente.
  }
}

export async function clearPaymentAccountDraft(): Promise<void> {
  try {
    await AsyncStorage.removeItem(DRAFT_STORAGE_KEY);
  } catch {
    // idem
  }
}
